'use strict';
import angular from 'angular';
import './task.constants';
import './scripts/task.services';

angular.module('core.tasks', [
    'task.services',
    'task.constants'
]);